var _module = require('../components/module');

/*
titleCase
converts the first character of every word (space separated) in the input string
to uppercase and the remaining characters of the word to lowercase
*/

_module.filter('titleCase', [
    function titleCase() {
        return function(str) {
            return (str||'')
                .split(' ')
                .map(function (w) {
                    return w.charAt(0).toUpperCase() + w.substr(1).toLowerCase();
                })
                .join(' ')
                .trim();
        };
}]);


